module.exports = __webpack_public_path__ + "img/auditExpiry.3d5394db.png";